import { resolveLocale, isRtl } from './translate'
import type { Locale } from './resources'

const readLangFromCookie = (cookieHeader: string | null): string | null => {
  if (!cookieHeader) return null
  const cookies = cookieHeader.split(';')
  for (const cookie of cookies) {
    const [name, ...rest] = cookie.trim().split('=')
    if (name === 'lang') {
      return decodeURIComponent(rest.join('='))
    }
  }
  return null
}

export const getLocaleFromRequest = (request: Request): Locale => {
  const url = new URL(request.url)
  const fromQuery = url.searchParams.get('lang')
  if (fromQuery) return resolveLocale(fromQuery)

  const fromCookie = readLangFromCookie(request.headers.get('cookie'))
  if (fromCookie) return resolveLocale(fromCookie)

  const acceptLanguage = request.headers.get('accept-language')
  const fromHeader = acceptLanguage?.split(',')[0] ?? null

  return resolveLocale(fromHeader)
}

export const getLocaleFromUrl = (url: URL | string): Locale => {
  const parsed = typeof url === 'string' ? new URL(url, 'http://localhost') : url
  return resolveLocale(parsed.searchParams.get('lang'))
}

export const getTextDirection = (locale: Locale): 'ltr' | 'rtl' => (isRtl(locale) ? 'rtl' : 'ltr')
